import { render } from "./currency-disclaimer.vue?vue&type=template&id=d64b99b4"
import script from "./currency-disclaimer.vue?vue&type=script&lang=js"
export * from "./currency-disclaimer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__